import React from 'react';
import { Container, Graphics } from '@pixi/react';
import { isMobile } from '../../../../core/helpers/isMobile';
import GameBackgroundWrapper from '../../../../containers/common/gameBackgroundWrapper';

function IntroBackground() {
  return (
    <Container name='IntroContent'>
      <GameBackgroundWrapper />
      {!isMobile() && (
        <Graphics
          draw={(g) => {
            g.clear();
            g.beginFill('black');
            g.alpha = 0.5;
            g.drawRect(0, 0, isMobile() ? 540 : 1440, isMobile() ? 960 : 810);
          }}
        />
      )}
    </Container>
  );
}
export default IntroBackground;
